(() => {
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[data-variant-link]');
    if (!link) return;
    const section = link.closest('[data-product-section]');
    if (!section || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();

    const fieldsets = [...section.querySelectorAll('fieldset')];
    const fieldsetIndex = fieldsets.indexOf(link.closest('fieldset'));
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', section.dataset.sectionId);

    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(response.statusText);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('[data-product-section]');
      if (!fresh) throw new Error('missing section');
      section.replaceWith(fresh);
      url.searchParams.delete('section_id');
      window.history.replaceState({}, '', url);
      const target = fresh.querySelectorAll('fieldset')[fieldsetIndex];
      const selected = target && target.querySelector('[aria-current="true"]');
      if (selected) selected.focus({ preventScroll: true });
    } catch (error) {
      window.location.href = link.href;
    }
  });

  document.addEventListener('change', (event) => {
    const form = event.target.closest('form[data-auto-submit], form.loc-form');
    if (form) form.requestSubmit();
  });
})();
